/**
 * The screens a watcher may send a device to.
 *
 * A mirror of `REMOTE_ROUTES` in the mobile app, and deliberately only a mirror: this list decides
 * what the portal *offers*, and the device's own copy decides what it *accepts*. The device is the
 * one that matters. If these two drift, the worst case is a button here that the phone declines,
 * which shows up in the feed as "route not allowed" — the failure is visible and safe, which is the
 * right way round for a list whose job is to be restrictive.
 *
 * Read-only destinations only. Nothing that starts a session, spends money, or lands mid-flow in
 * the player: being able to look at a screen with somebody is the use case, and driving them into
 * an action is not.
 */
export const REMOTE_ROUTES: Array<{ name: string; label: string }> = [
  { name: 'home', label: 'Home' },
  { name: 'discover', label: 'Discover' },
  { name: 'my-adventures', label: 'My Adventures' },
  { name: 'profile', label: 'Profile' },
  { name: 'settings', label: 'Settings' },
  { name: 'notifications', label: 'Notifications' },
  { name: 'messages', label: 'Messages' },
  { name: 'trails', label: 'Trails' },
]
